import { URL_PARAM_KEY_IS_ADMIN_PREVIEW } from './constants';

let isAdminPreview = false;

const isAdminPreviewIFrame = () => window.frameElement?.dataset?.vm2AdminPreview === 'true';
const hasUrlSearchParam = (url) => new URL(url).searchParams.has(URL_PARAM_KEY_IS_ADMIN_PREVIEW);

export const detectAdminPreview = (url) => {
  try {
    isAdminPreview = hasUrlSearchParam(url) || isAdminPreviewIFrame();
  } catch (e) {
    isAdminPreview = false;
  }
};

export const getIsAdminPreview = () => isAdminPreview;
